<template>
  <div class="home">
    <Banner />
    <AboutUs />
    <Mission />
    <Services />
    <Partners />
    <Achievements />
    <Contact />
    <a href="#" class="float" v-scroll-to="'#banner'">
      <i class="fas fa-arrow-up my-float"></i>
    </a>
  </div>
</template>

<script>
import Banner from "./../components/Banner.vue";
import AboutUs from "./../components/AboutUs";
import Mission from "./../components/Mission";
import Services from "./../components/Services";
import Achievements from "./../components/Achievements";
import Contact from "./../components/Contact";
import Partners from "./../components/Partners";
export default {
  name: "Home",
  components: {
    Banner,
    AboutUs,
    Mission,
    Services,
    Achievements,
    Contact,
    Partners
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0), { behavior: "smooth" };
    }
  }
};
</script>

<style scoped>
.float {
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 40px;
  right: 40px;
  font-size: 28px;
  color: #111;
  border-radius: 50px;
  text-align: center;
  /* box-shadow: 2px 2px 3px #999; */
  z-index: 99999;
  cursor: pointer;
}

.float:hover {
  transform: scale(1.2);
  transition: all 0.5s;
}

span {
  /* box-shadow: 3px 3px 5px grey; */
}

span i {
  color: var(--rotary-gold);
}
.my-float {
  margin-top: 22px;
}
</style>
